import { useState, useEffect } from 'react'
import { makeStyles } from "@material-ui/core/styles"
import { styled, useTheme } from "@mui/material/styles"
import { Box, Typography } from '@mui/material'
import commandsProvider from '../providers/CommandsProvider'

/*export default function Footer(props) {
    const buildVersion = useState(process.env.REACT_APP_BUILD_VERSION)*/


const useStyles = makeStyles((theme) => {
    return {
        footerLicence: {
            backgroundColor: "#30D253",
            color: "#121312",
        },
        footerLicenceWarning: {
            backgroundColor: "#F42F3E",
            color: "#fffffff",
        }
    }
})


const FooterBar = styled('footer', {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: "100%",
    position: "fixed",
    bottom: 0,
    zIndex: "1",
    alignItems: "center",
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        [theme.breakpoints.up('sm')]: {

            width: `calc(100% - 240px)`,
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

export default function Footer(props) {
    const buildVersion = useState(process.env.REACT_APP_BUILD_VERSION)
    const [updateInfo, setUpdateInfo] = useState({ canUpdate: false, version: "" });

    const [hasUpdate, setHasUpdate] = useState({ update: false, internet: false, version: "" });
    const [showUpdate, setshowUpdate] = useState(true);
    const user = localStorage.getItem("user") !== null ? JSON.parse(localStorage.getItem("user")) : "";

   /* useEffect(() => {
        verifyIfUserExists();
    },[]);*/

    const token = localStorage.getItem("token") !== null ? localStorage.getItem("token") : "";

    const BgColour = () => {

        if (!updateInfo.canUpdate  || process.env.REACT_APP_MODE === 'web') {
            return "#212121"

        }
        else {
            if (user.role.tecnico === true ) return "#F58634" //laranja
            //else return "#212121"; // cinza para QA
            else return "#5ACBFA"; //azul
        }
    }
    
    const UpdateSystem = () => {
        document.querySelector('.hidden[data-action="update-system"]').click();
    };

    const handleUpdate = (state) => {
        setUpdateInfo(state.updateVersionInfo);
    };
    
    useEffect(() => {
        commandsProvider.subscribe(handleUpdate);
        return () => commandsProvider.unsubscribe(handleUpdate);
    }, []);


    return (
        <FooterBar open={props.open}>
            <Box
                sx={{
                    width: "100%",
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0.5rem',
                    backgroundColor: BgColour,
                    fontWeight: 'bold',
                    color: process.env.REACT_APP_MODE === 'desktop' && updateInfo.canUpdate  ? '#212121' : 'inherit'
                }}
            >
                <Typography textAlign="center" variant="body2">
                { !!props.serial && 
                    <>
                        Central: {props.serial}
                    </>
                }
                </Typography>

                { process.env.REACT_APP_MODE === 'desktop' && updateInfo.canUpdate ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <button
                            className="button button--transparent mx-auto"
                            style={{ "color": "#212121", "textDecoration": "underline" }}
                            onClick={() => { UpdateSystem() }}
                        >
                            NOVA VERSÃO ENCONTRADA! CLIQUE AQUI PARA ATUALIZAR!
                        </button>
                    </Box>
                ) : null }


                {process.env.REACT_APP_MODE === 'desktop' ? (
                    <Typography textAlign="end" variant="body2">v{buildVersion}</Typography>
                ) : null}
            </Box>
        </FooterBar>
    )

}